import React, { useState, useEffect } from "react";
import axios from "axios";
import App1 from './App1';
import Login from "./Login";
import "./assets/bootstrap-5.3.2-dist/css/bootstrap.min.css";
import bootjs from "./assets/bootstrap-5.3.2-dist/js/bootstrap.min.js";
import './login.css';
import Source from "./Source.js";
// import { useSelector, useDispatch } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux';
// import { useSelector, useDispatch } from 'react-redux';
import { getReports} from './pages/Redux/reportSlice.js';
import { getBelances } from "./pages/Redux/belanceSlice.js";
import { getCustomers } from "./pages/Redux/customerSlice.js";
import { getMoneys } from "./pages/Redux/moneysSlice.js";
import { getItems } from "./pages/Redux/itemSlice.js";
import { Checkuser } from "./pages/Checkuser.js";
import Loginfinal from './login/Loginfinal.js';
import { getUsers } from "./pages/Redux/userSlice.js";
import { getTailors } from "./pages/Redux/tailorSlice.js";
// import AlertHelper from './warrper.js'

// import React, { useEffect } from 'react';
export default function App() {
    const dispatch = useDispatch();
    const [correct, setCorrect] = useState(false);
    const [error, setError] = useState(null);
    const [loguser, setLoguser] = useState({});
    const [type, setType] = useState('simple');
    const check = async (user) => {
        try {
            // Checkuser(user);
            const res = await axios.post(Source.getAddress()+'/api/login', user);
            localStorage.setItem('access', res.data.token);
            localStorage.setItem('userTokenname',res.data.user.category);
            localStorage.setItem('userTokenid',res.data.user.id);
            localStorage.setItem('userToken',res.data.user.name);
            localStorage.setItem('isTransactionsExpanded', false);
            localStorage.setItem('toggle', 'true');
            setCorrect(true);
            localStorage.setItem("draftCollapseState", true);
            localStorage.setItem("transactionCollapseState", true);
                localStorage.setItem("StockCollapseState", true);
                localStorage.setItem("ReportCollapseState", true);
                localStorage.setItem("transactionCollapseState", true);
                localStorage.setItem("ReportCollapseState", true);
                localStorage.setItem("draftCollapseState", true);
                // localStorage.setItem("language", 'en');
                // localStorage.setItem("date", 'en');
                window.location.pathname = '/';
        } catch (err) {
            setCorrect(false);
            setError('Invalid username or password');
            localStorage.removeItem("access");
            localStorage.removeItem("refresh");
        }
    };

    let Component;
    if (localStorage.getItem('access')||correct) {
        Component = <App1 type={type} setLoguser={setLoguser} loguser={loguser} setCorrect={setCorrect} setError={setError} />;
    } else {
        switch (window.location.pathname) {
            case '/':
                // Component = <Login check={check} error={error} />;
                // Component=<Loginfinal check={check} error={error}/>;
                Component = <Loginfinal check={check} error={error} />;
                break;
            default:
                // Component = <Login check={check} error={error} />;
                Component=<Loginfinal check={check} error={error}/>;

        }
    }
    return (
        <div className={`App ${localStorage.getItem("language") === "en" ? "" : "afgFont"}`}>
             {/* <AlertHelper> */}
            {Component}
             {/* </AlertHelper> */}
        </div>
    );
}
